import { http } from '../../config/axios'

export default function postOpcaoConsultaLote(opcaoConsultaLote: any): Promise<string> {
  return http
    .post('api/opcaoconsultalote', opcaoConsultaLote)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro OpcaoConsultaLote', error)
      throw Error(error.response.data)
    })
}
